<template>
  <v-card class="minContent">
    <!--<v-card-title v-if="showEditor === false">-->
      <v-card-title>
      <v-menu
        offset-y
        v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :disabled="selected.length === 0"
            color="secondary"
          >
            <v-icon class="mr-2">mdi-menu-down</v-icon>
            {{ $t("base.actions") }}
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            @click="editDriveType()"
            :disabled="selected.length !== 1"
          >
            <v-icon class="mr-4">mdi-pencil</v-icon>
            {{ capitalizeString("base.edit")}}
          </v-list-item>
          <!--
          <v-list-item @click="deleteDriveTypes()">
            <v-icon class="mr-4">mdi-delete-forever</v-icon>
            {{ capitalizeString("base.delete")}}
          </v-list-item>
          -->
          <v-list-item @click="exportData()">
            <v-icon class="mr-4">mdi-export</v-icon>
            {{ capitalizeString('base.export') }}
          </v-list-item>
        </v-list>
      </v-menu>
      <span
        v-if="hasUserRight('manageBaseData')"
        class="ml-8 body-1"
      >
        {{ selected.length + " " + $t('base.of') + " " + filteredList.length + " " + $t('base.selected') }}
      </span>
      <v-spacer />
      <v-btn
        v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
        @click="createDriveType()"
        color="secondary"
        class="mr-8"
        v-tooltip="$tooltip($t('condAdmin.tooltip.newDriveType'))"
      >
        <v-icon class="mr-2">mdi-plus</v-icon>
        {{ $t("base.new") }}
      </v-btn>
      <v-icon
        @click="getDriveTypeList()"
        color="secondary"
        class="mr-8"
        v-tooltip="$tooltip($t('condAdmin.tooltip.refresh'))"
      >mdi-reload</v-icon>
      <v-menu
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            color="secondary"
            v-tooltip="$tooltip($t('condAdmin.tooltip.menu'))"
          >mdi-format-columns</v-icon>
        </template>

        <v-list>
          <v-list-item
            v-for="(col, index) in availableColumns"
            :key="index"
          >
            <v-checkbox
              v-model="availableColumns[index].active"
              :label="$t(availableColumns[index].text)"
              @change="setAvailableHeaders(availableColumns[index],$event)"
            ></v-checkbox>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-icon
        @click="saveUserTableSettings('driveTypeTable')"
        color="secondary"
        class="ml-8"
        v-tooltip="$tooltip($t('condAdmin.tooltip.save'))"
      >mdi-content-save-cog</v-icon>
      <JsonImporter
        v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true"
        class="ml-8"
        objectType="driveTypes"
        module="condAdmin"
        :preImportCheck="preImportCheckFunction"
        @import="importData"
      />
    </v-card-title>

    <v-card-text  class="pt-4">
      <v-row no-gutters>
        <v-col cols="12">
          <v-data-table
            ref="DriveTypeDT"
            v-model="selected"
            :headers="listHeaders"
            :items="filteredList"
            :items-per-page="footerProps.itemsPerPage"
            :footer-props="footerProps"
            item-key="uid"
            show-select
            fixed-header
            :sort-by="listSortKey"
            @click:row="clickedRow"
            :loading="$store.state.condAdmin.driveTypesLoading"
            @update:items-per-page="getItemPerPage"
          >
            <template v-slot:body.prepend="{}">
              <tr>
                <td></td>
                <td
                  v-for="(h, index) in listHeaders"
                  :key="index"
                >
                  <SearchField
                    v-if="filter.hasOwnProperty(h.value) && filter[h.value].type === 'SearchField'"
                    :value="filter[h.value].value"
                    @filter="applyFilters($event, h.value)"
                  />
                </td>
              </tr>
            </template>
            <template v-slot:header.data-table-select="{ on, props }">
              <v-simple-checkbox
                color="secondary"
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:header.menu="{}">
            </template>
            <template v-slot:item.name="{item}">
              <v-edit-dialog
                :ref="'DriveTypeDlg_' + item.driveTypeUid"
                :return-value.sync="item.name"
                large
                cancel-text="Abbrechen"
                save-text="speichern"
                @save="saveDriveType(item)"
                >
                {{ item.name }}
                <template v-slot:input>
                  <div class="mt-4 text-h6">
                    {{ capitalizeString('condAdmin.driveTypeList.headline') }}
                  </div>
                  <v-text-field
                    v-model="item.name"
                    :rules="[max45chars]"
                    label="Edit"
                    single-line
                    counter
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.menu="{ item }">
              <v-menu
                offset-y
                v-if="hasUserRight('manageBaseData') && getOrgSetting('createOwnData') === true && item.inherited !== true"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="editDriveType(item)">
                    <v-icon class="mr-4">mdi-pencil</v-icon>
                    {{ $t("base.edit")}}
                  </v-list-item>
                  <!--
                  <v-list-item @click="deleteDriveType(item)">
                    <v-icon class="mr-4">mdi-delete-forever</v-icon>
                    {{ $t("base.delete")}}
                  </v-list-item>
                  -->
                </v-list>
              </v-menu>

              <v-chip
                v-if="item.inherited === true"
                v-tooltip="$tooltip($t('condAdmin.driveType.inheriteddriveType'))"
              >
                <v-icon>mdi-link-lock</v-icon>
              </v-chip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <JsonExporter
      objectType="driveTypes"
      module="condAdmin"
      ref="jsonExporter"
    />
    <DoubletDlg
      ref="doubletDlg"
      :fields="doubletFields"
      :hint="this.$t('condAdmin.productTypeList.importDoublet')"
    />
  </v-card>
</template>

<script lang="js">
import { refreshDriveTypeList } from '../js/condAdminHelper.js';
import { isProcessStateOK, newMessage } from '@/base/js/ProcessDataHelper';
import { complexFilter } from '@/base/js/ObjectHelper';
import condAdminMixin from '../js/condAdminMixin.js';
import SearchField from '@/common/SearchField';
import JsonImporter from '@/common/JsonImporter';
import JsonExporter from '@/common/JsonExporter';
import DoubletDlg from '@/common/DoubletDlg';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'DriveTypeTable',
  components: {
    SearchField,
    JsonImporter,
    JsonExporter,
    DoubletDlg
  },
  mixins: [ condAdminMixin ],
  data () {
    return {
      driveTypeList: [],
      showEditor: false,
      editedItem: null,
      selected: [],
      listSortKey: 'name',
      max45chars: v => v.length <= 45 || 'maximal 45 Zeichen',
      footerProps: {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions: [5, 15, 30, 50, -1],
        itemsPerPage: 15
      },
      filteredList: [],
      availableColumns: [
        { text: this.$t('condAdmin.driveType.name'), active: true, value: 'name' }
      ],
      filter: {
        name: { condition: 'startsWith', value: null, type: 'SearchField' }
      },
      doubletFields: [
        { key: 'name', text: this.$t('condAdmin.driveType.name'), unique: true, readonly: false }
      ]
    };
  },
  computed: {
    listHeaders () {
      let h = [];
      for (let mc of this.availableColumns) {
        if (mc.active === true) {
          h.push(mc);
        }
      }
      h.push({ text: 'menu', value: 'menu', sortable: false });
      return h;
    }
  },
  async mounted () {
    this.getUserTableSettings('driveTypeTable');
    if (this.$store.state.condAdmin.driveTypeList === null) {
      await refreshDriveTypeList();
    }
    this.filteredList = complexFilter(this.$store.state.condAdmin.driveTypeList, this.filter);
  },
  methods: {
    async checkLeave () {
      if (this.showEditor === true) {
        return this.$refs.driveTypeDetail.checkLeave();
      }
      return true;
    },
    async getDriveTypeList () {
      await refreshDriveTypeList();
      this.filteredList = complexFilter(this.$store.state.condAdmin.driveTypeList.filter((e) => e.state === 6 || e.state === 0), this.filter);
    },
    async deleteDriveTypes () {
      if (await this.$globals.Confirm.yesNoDlg(this.$t('condAdmin.driveTypeList.deleteDriveType'), this.$t('condAdmin.driveTypeList.deleteDriveTypesConfirmText'))) {
        for (let driveType of this.selected) {
          this.callDeleteDriveTypeService(driveType);
        }
      }
    },
    async deleteDriveType (driveType) {
      // show confirmation dialog
      if (await this.$globals.Confirm.yesNoDlg(this.$t('condAdmin.driveTypeList.deleteDriveType') + ': ' + driveType.name, this.$t('condAdmin.driveTypeList.deleteDriveTypeConfirmText'))) {
        this.callDeleteDriveTypeService(driveType);
      }
    },
    callDeleteDriveTypeService (driveType) {
      let ioData = {
        clientKey: this.$store.state.condAdmin.clientKey,
        driveType: {
          uid: driveType.uid,
          driveTypeUid: driveType.driveTypeUid
        }
      };
      this.$restClient.callProcess('condAdmin', 'deleteDriveType', ioData).then(
        (processData) => {
          if (isProcessStateOK(processData)) {
            this.$globals.Info.open([{ type: 'success', message: this.$t('condAdmin.driveTypeList.deletedDriveType', { driveType: driveType.name }) }]);
          } else {
            this.$globals.Info.open(processData.processState.messages);
          }
          this.$store.state.condAdmin.driveTypeList.splice(this.$store.state.condAdmin.driveTypeList.findIndex((p) => p.uid === driveType.uid), 1);
          this.filteredList = complexFilter(this.$store.state.condAdmin.driveTypeList.filter((e) => e.state === 6 || e.state === 0), this.filter);
        }
      );
    },
    async createDriveType () {
      this.editedItem = { uid: null, name: '', driveTypeUid: uuidv4(), state: 6 };
      this.filteredList.push(this.editedItem);
      this.$nextTick(() => {
        this.editDriveType(this.editedItem);
      });
    },
    editDriveType (driveType = null) {
      if (driveType == null) {
        driveType = this.selected[0].uid;
      }
      this.editedItem = JSON.parse(JSON.stringify(driveType));
      console.debug('this.$refs', this.$refs);
      this.$refs['DriveTypeDlg_' + driveType.driveTypeUid].isActive = true;
    },
    cancelEditDriveType () {
      this.showEditor = false;
      this.editedItem = null;
    },
    async saveDriveType (driveType) {
      let processName = 'updateDriveType';
      let ioData = {
        clientKey: this.$store.state.condAdmin.clientKey,
        driveType: {
          name: driveType.name,
          driveTypeUid: driveType.driveTypeUid
        }
      };

      if (driveType.uid == null) {
        processName = 'createDriveType';
      } else {
        ioData.driveType.uid = driveType.uid;
      }

      await this.$restClient.callProcess('condAdmin', processName, ioData).then(
        (processData) => {
          if (isProcessStateOK(processData)) {
            if (driveType.uid != null) {
              this.$store.state.condAdmin.driveTypeList.splice(
                this.$store.state.condAdmin.driveTypeList.findIndex((p) => p.uid === driveType.uid), 1
              );
            }
            this.$store.state.condAdmin.driveTypeList.push(processData.ioData.driveType);
            this.filteredList = complexFilter(this.$store.state.condAdmin.driveTypeList.filter((e) => e.state === 6 || e.state === 0), this.filter);
            this.editedItem = null;
            this.$globals.Info.open([{ type: 'success', message: this.$t('condAdmin.driveTypeList.savedDriveType', { driveType: driveType.name }) }]);
          } else {
            this.$globals.Info.open(processData.processState.messages);
          }
        }
      );
      await this.getDriveTypeList();
    },

    clickedRow (driveType) {
      if (this.hasUserRight('manageBaseData') === true && this.getOrgSetting('createOwnData') === true && driveType.inherited !== true) {
        this.editDriveType(driveType);
      }
    },
    getItemPerPage (val) {
      this.footerProps.itemsPerPage = val;
      this.$store.state.condAdmin.userSettings['driveTypeTable'].footerPropItemsPerPage = val;
    },
    setAvailableHeaders (column, value) {
      this.$store.state.condAdmin.userSettings['driveTypeTable'].columns[column.value] = value;
    },
    applyFilters (value, filtername) {
      this.filter[filtername].value = value;
      this.filteredList = complexFilter(this.$store.state.condAdmin.driveTypeList, this.filter);
      this.$store.state.condAdmin.userSettings['driveTypeTable'].filter[filtername] = value;
    },
    exportData () {
      let driveTypes = JSON.parse(JSON.stringify(this.selected));
      this.$refs.jsonExporter.exportJsonData({ driveTypes });
    },
    async importData (json) {
      await refreshDriveTypeList();
      let imported = 0;
      let total = json.data.driveTypes.length;

      for (let imp of json.data.driveTypes) {
        // check already existing dealerKey
        let existing = this.importUniqueCheck(imp);
        if (existing != null) {
          // build temporay subProductTypeList to be displayed in doubletDlg
          existing.stList = '';
          existing.stList = existing.stList.substring(2);
          imp.stList = [];

          let [action, merged] = await this.$refs.doubletDlg.show(existing, imp);
          switch (action) {
            case 'overwrite':
              merged.uid = existing.uid;
              delete merged.stList;
              await this.saveDriveType(merged);
              // console.log('imported', JSON.stringify(merged));
              imported++;
              break;
            case 'copy':
              delete merged.stList;
              await this.saveDriveType(merged);
              // console.log('imported', JSON.stringify(merged));
              imported++;
              break;
            case 'skipNew':
            default:
              break;
          }
        } else {
          await this.saveDriveType(imp);
          // console.log('imported', JSON.stringify(imp));
          imported++;
        }
      }
      this.$globals.Info.open([ newMessage('success', this.$t('condAdmin.importResult', { imported, total })) ]);
      if (imported > 0) refreshDriveTypeList();
    },
    preImportCheckFunction (json) {
      if (json.data.driveTypes == null || json.data.driveTypes.length < 1) {
        this.$globals.Info.open([ newMessage('userError', this.$t('condAdmin.driveTypeList.noImportData')) ]);
        return false;
      }
      return true;
    },
    importUniqueCheck (merged) {
      let existing = this.$store.state.condAdmin.driveTypeList.find((i) => i.name === merged.name && i.uid !== merged.uid);
      return existing;
    }
  }
};
</script>

<style scoped>
</style>
